import { render, staticRenderFns } from "./blogcategorydetails.vue?vue&type=template&id=a64f5826&scoped=true"
import script from "./blogcategorydetails.vue?vue&type=script&lang=js"
export * from "./blogcategorydetails.vue?vue&type=script&lang=js"
import style0 from "./blogcategorydetails.vue?vue&type=style&index=0&id=a64f5826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64f5826",
  null
  
)

export default component.exports